import FlexLayout from "@components/FlexLayout/index.jsx";
import { data } from "./data.js";
import { motion } from "framer-motion";

export const TypesOfWebApplications = () => {
  return (
    
      <FlexLayout
        heading={data.heading}
        text={data.text}
        list={data.list}
        img={data.img}
        alt={data.altText}
      />
   );
};
